import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const activityLogService = {
  getAllUsers,
  getAuditBy,
  getActivityLog,
};

function getAllUsers(params) {
  return apiCall("GET", API_URLS.USERS.GET_USERS, null, null, params);
}
function getAuditBy() {
  return apiCall("GET", API_URLS.ACTIVITY_LOG.GET_AUDIT_BY);
}

function getActivityLog(params, data) {
  if (params && params.fileType) {
    if (params.fileType === "PDF") {
      params["encode"] = true;
      return apiCall(
        "GET",
        `${API_URLS.ACTIVITY_LOG.GET_ACTIVITY_LOG}`,
        null,
        data,
        params
      );
    } else {
      return apiCall(
        "GET",
        `${API_URLS.ACTIVITY_LOG.GET_ACTIVITY_LOG}`,
        null,
        data,
        params
      );
    }
  } else {
    return apiCall(
      "GET",
      `${API_URLS.ACTIVITY_LOG.GET_ACTIVITY_LOG}`,
      null,
      data,
      params
    );
  }
}
